export default "__VITE_ASSET__162a38e0__"